import { render, staticRenderFns } from "./NlpPhrase.vue?vue&type=template&id=ed1ae7fe&"
import script from "./NlpPhrase.vue?vue&type=script&lang=js&"
export * from "./NlpPhrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports